import axiosInstance from "api/setupAxios";

const profileApi = {
  getUserProfileByIdApi: async (userId) => {
    const { data } = await axiosInstance.get(`/user/${userId}`);
    return data;
  },

  // Update preferred currency for both agency and freelancer
  updatePreferredCurrency: async (payload) => {
    const { data } = await axiosInstance.post("/user/preferredCurrency", {
      ...payload,
    });
    return data;
  },

  // Update bank details for both agency and freelancer (common endpoint)
  updateBankDetailsCommon: async (payload = {}) => {
    const { data } = await axiosInstance.post("/user/bankDetails", payload);
    return data;
  },

  // Update Ureed for both agency and freelancer (common endpoint)
  updateUreedCommon: async (payload = {}) => {
    const { data } = await axiosInstance.post("/user/ureed", payload);
    return data;
  },
  // Update Payoneer for both agency and freelancer (common endpoint)
  updatePayoneerCommon: async (payload = {}) => {
    const { data } = await axiosInstance.post("/user/payoneer", payload);
    return data;
  },

  // Update Cash Express for both agency and freelancer (common endpoint)
  updateCashExpressCommon: async (payload = {}) => {
    const { data } = await axiosInstance.post("/user/cashExpress", payload);
    return data;
  },

  updateVatCommon: async (payload = {}) => {
    const { data } = await axiosInstance.post("/user/vat", payload);
    return data;
  },

  getUserDomainsByIdApi: async (userId) => {
    const domains = await axiosInstance.get(`/user/${userId}/domains`);

    return domains;
  },

  getUserSubDomainsByIdApi: async (userId) => {
    const subDomains = await axiosInstance.get(`/user/${userId}/subDomains`);
    return subDomains;
  },

  updateUserPasswordApi: async (payload = {}) => {
    const data = await axiosInstance.patch("/user/updatePassword", payload);
    return data;
  },
  updatePersonalDetailsApi: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/personalDetails`,
      payload
    );
    return data;
  },

  updateVendorExperienceApi: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/experience`,
      payload
    );
    return data;
  },

  updateAgencyExperienceApi: async (agencyId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/agency/${agencyId}/experience`,
      payload
    );
    return data;
  },

  updateVendorResume: async (vendorId, payload = {}) => {
    const data = await axiosInstance.patch(
      `/vendor/${vendorId}/resumes`,
      payload
    );
    return data;
  },

  updateRelevantProfile: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/relevantProfiles`,
      payload
    );
    return data;
  },

  updateVendorCertificationApi: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/certifications`,
      payload
    );
    return data;
  },

  updateAgencyFiles: async (agencyId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/agency/${agencyId}/files`,
      payload
    );
    return data;
  },

  updateCompanyDetails: async (agencyId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/agency/${agencyId}/companyDetails`,
      payload
    );
    return data;
  },

  updateVendorServices: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/skills`,
      payload
    );
    return data;
  },

  updateAgencyServices: async (agencyId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/agency/${agencyId}/skills`,
      payload
    );
    return data;
  },

  getFileUrlApi: async (fileId) => {
    const { data } = await axiosInstance.get(`/user/file/${fileId}/url`);
    return data;
  },

  updateAdditionalVendorInfo: async (vendorId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/vendor/${vendorId}/additionalInfo`,
      payload
    );
    return response;
  },

  updateAdditionalAgencyInfo: async (agencyId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/agency/${agencyId}/additionalInfo`,
      payload
    );
    return response;
  },

  updateVendorQualifications: async (vendorId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/vendor/${vendorId}/qualifications`,
      payload
    );
    return response;
  },

  updateBankDetails: async (vendorId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/vendor/${vendorId}/bankDetails`,
      payload
    );
    return response;
  },

  updateEmergencyContact: async (vendorId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/vendor/${vendorId}/emergencyContacts`,
      payload
    );
    return response;
  },

  updateAgencyBankDetails: async (agencyId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/agency/${agencyId}/bankDetails`,
      payload
    );
    return response;
  },

  updateLegalDetails: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/legalDetails`,
      payload
    );
    return data;
  },

  updateVendorContactDetails: async (vendorId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/vendor/${vendorId}/contacts`,
      payload
    );
    return response;
  },

  updateAgencyContactDetails: async (agencyId, payload = {}) => {
    const response = await axiosInstance.patch(
      `/agency/${agencyId}/contacts`,
      payload
    );
    return response;
  },

  updateVenderVatCertification: async (vendorId, payload = {}) => {
    const { data } = await axiosInstance.patch(
      `/vendor/${vendorId}/vatCertification`,
      payload
    );
    return data;
  },

  getAgencyTeamApi: async (query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 6, pageNumber = 1 } = paginate;

    if (query.filter?.value?.length > 0) {
      query.filter = JSON.stringify(query.filter);
    } else {
      delete query.filter;
    }

    const data = await axiosInstance.get(`/agencyUsers`, {
      params: {
        paginate: JSON.stringify({
          pageSize: pageSize,
          pageNumber,
        }),
        filter: query.filter,
      },
    });
    return data;
  },

  createAgencyTeamMemberApi: async (payload = {}) => {
    const data = await axiosInstance.post(`/agencyUser`, payload);
    return data;
  },

  updateAgencyTeamMemberApi: async (userId, payload = {}) => {
    const data = await axiosInstance.patch(`/agencyUser/${userId}`, payload);
    return data;
  },
  modifyActivityAgencyTeamMemberApi: async (userId) => {
    const data = await axiosInstance.patch(`/agencyUser/${userId}/activity`);
    return data;
  },
  uploadUserLogoApi: async (formData) => {
    // Matches swagger: PATCH /client/user/logo with multipart form field 'logo'
    const { data } = await axiosInstance.patch("/user/logo", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },
  deleteUserLogoApi: async () => {
    const { data } = await axiosInstance.delete("/user/logo");
    return data;
  },
};

export default profileApi;
